import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../environments/environment';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {
  private loaded = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
        @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  loadGoogleMapsScript(): Promise<void> {
      if (!isPlatformBrowser(this.platformId)) {
      // Côté serveur, on ne fait rien
      return Promise.resolve();
    }
  if (this.loaded) {
    return Promise.resolve();
  }

  if (typeof window === undefined || typeof document === undefined) {
    return Promise.reject(new Error('Not in a browser environment'));
  }

  const existingScript = this.document.querySelector(
    'script[src^="https://maps.googleapis.com/maps/api/js"]'
  );

  
  if (existingScript) {
    this.loaded = true;
    return Promise.resolve();
  }

  let script = this.document.createElement('script');
    script.defer = true;
  script.async = true;
  script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.apiKeyGoogleMap}&libraries=places,marker&region=MA`;

  script.setAttribute('loading', 'async'); 

  const promise = new Promise<void>((resolve, reject) => {
    script.onload = () => {
      this.loaded = true;
      resolve();
    };
    script.onerror = () => {
      reject(new Error('Failed to load Google Maps script'));
    };
  });

  this.document.body.appendChild(script);
  return promise;
  }

}
